import service from "../libs/request.js";

// 获取护理专业发展
var getCareInfo = function(postdata, callback) {
  service.get({
    url: "/wzMedicalCare/getCareInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取护理专业发展列表
var getCareList = function(postdata, callback) {
  service.get({
    url: "/wzMedicalCare/getCareList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取科室树;
var getKsTree = function(postdata, callback) {
  service.get({
    url: "/resetful",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取科室信息
var getDepartmentInfo = function(postdata, callback) {
  service.get({
    url: "/resetful/getDepartment",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取科室医生列表
var getArcDocList = function(postdata, callback) {
  service.get({
    url: "/resetful/ksDocList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取医生
var getDoctorDetail = function(postdata, callback) {
  service.get({
    url: "/resetful/getKsDoc",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取特色医疗中心
var getCenterInfo = function(postdata, callback) {
  service.get({
    url: "/wzMedicalCare/getCenterInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取特色医疗中心列表
var getCenterList = function(postdata, callback) {
  service.get({
    url: "/wzMedicalCare/getCenterList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取国家临床重点专科
var getKeyInfo = function(postdata, callback) {
  service.get({
    url: "/wzMedicalCare/getKeyInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取先进设备列表
var getEquipmentList = function(postdata, callback) {
  service.get({
    url: "/wzMedicalCare/getEquipmentList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取先进设备
var getEquipmentInfo = function(postdata, callback) {
  service.get({
    url: "/wzMedicalCare/getEquipmentInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 搜索
var getDiseaseList = function(postdata, callback) {
  service.get({
    url: "/wzIndexSelect/getDiseaseList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
var getDocDepartList = function(postdata, callback) {
  service.get({
    url: "/wzIndexSelect/getDocDepartList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 获取盛京看点列表
var getWatchList = function(postdata, callback) {
  service.get({
    url: "/wzSjWatch/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });

};

// 获取媒体看盛京列表
var getwzMediaViewsjList = function(postdata, callback) {
  service.get({
    url: "/wzMediaViewsj/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// 公用 index.js


// 获取医疗纵横列表;
var getwzMedicalAffairsList = function(postdata, callback) {
  service.get({
    url: "/wzMedicalAffairs/getList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
// ,
// getwzMedicalAffairsList,
export default {
  getCareInfo,
  getCareList,
  getKsTree,
  getDepartmentInfo,
  getArcDocList,
  getDoctorDetail,
  getCenterInfo,
  getCenterList,
  getKeyInfo,
  getWatchList,
  getwzMediaViewsjList,
  getwzMedicalAffairsList,
  getEquipmentList,
  getEquipmentInfo,
  getDiseaseList,
  getDocDepartList,
};
